import { render, staticRenderFns } from "./SongsPlaylistProfile.vue?vue&type=template&id=1ae9cd43&scoped=true"
import script from "./SongsPlaylistProfile.vue?vue&type=script&lang=js"
export * from "./SongsPlaylistProfile.vue?vue&type=script&lang=js"
import style0 from "./SongsPlaylistProfile.vue?vue&type=style&index=0&id=1ae9cd43&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ae9cd43",
  null
  
)

export default component.exports